import React from "react";
const LoadingUpload = (props) => {
  return (
    <>
      {props.isLoadingUpload && (
        // <div className="spinner-container">
        //   <div className="loading-spinner"></div>
        // </div>

        <div id="globalSpiner" className="overlay overlay-inner outer">
          <div className="inner">
            <div className="spinner"></div>

            <p>Hình ảnh đang được xử lý, bạn vui lòng chờ chút nhé!</p>
          </div>
        </div>
      )}
    </>
  );
};
export default LoadingUpload;
